import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const ContactsModelSchema = z
  .object({
    id: z.string(),
    first_name: z.string().nullish(),
    middle_name: z.string().nullish(),
    last_name: z.string().nullish(),
    preferred_name: z.string().nullish(),
    email: z.string().nullish(),
    email_other: z.string().nullish(),
    email_private: z.string().nullish(),
    business_phone: z.string().nullish(),
    mobile_phone: z.string().nullish(),
    gender: z.string().nullish(),
    address_1: z.string().nullish(),
    address_2: z.string().nullish(),
    address_3: z.string().nullish(),
    address_city_label: z.string().nullish(),
    address_city_code: z.number().nullish(),
    address_stateprovince: z.string().nullish(),
    address_postal_code: z.string().nullish(),
    address_country_label: z.string().nullish(),
    address_country_code: z.string().nullish(),
    linked_in_url: z.string().nullish(),
    photo_url: z.string().nullish(),
    notes: z.string().nullish()
  })
  .strict()

export const ContactsModelFields = makeFieldKeys(ContactsModelSchema)

export type ContactsModel = z.infer<typeof ContactsModelSchema>

function validateContactsModel(data: unknown): ContactsModel {
  try {
    return validateWithZodSchema(ContactsModelSchema, data, 'contacts model')
  } catch (error) {
    throw new Error(`Contacts model validation failed: ${error}`)
  }
}
